import React, { useEffect, useMemo, useRef, useState } from "react"
import "./HeatmapDashboard.css"
import redirectURL from "../../redirectURL"
import { AgGridReact } from "@ag-grid-community/react"
import { DashboardHeaderBanner } from "./DashboardHeaderSlot.jsx";
import "@ag-grid-community/core/dist/styles/ag-grid.css"
import "@ag-grid-community/core/dist/styles/ag-theme-balham.css"
import Select from "react-select"

var ALL_OPTION = { label: "All", value: "all" }

var MONTH_CONFIG = [
  { key: "april", label: "April", monthIndex: 3 },
  { key: "may", label: "May", monthIndex: 4 },
  { key: "june", label: "June", monthIndex: 5 },
  { key: "july", label: "July", monthIndex: 6 },
  { key: "august", label: "August", monthIndex: 7 },
  { key: "september", label: "September", monthIndex: 8 },
  { key: "october", label: "October", monthIndex: 9 },
  { key: "november", label: "November", monthIndex: 10 },
  { key: "december", label: "December", monthIndex: 11 },
  { key: "january", label: "January", monthIndex: 0 },
  { key: "february", label: "February", monthIndex: 1 },
  { key: "march", label: "March", monthIndex: 2 },
]

export default function HeatmapDashboard(props) {
  var activeSubTab = props.activeSubTab || "warehouse"

  var [loading, setLoading] = useState(false)
  var [lastRefreshTime, setLastRefreshTime] = useState(null)

  var defaultDates = useMemo(function () {
    var today = new Date()
    var to = formatDateInput(today)

    var fromObj = new Date(today)
    fromObj.setFullYear(fromObj.getFullYear() - 1)
    var from = formatDateInput(fromObj)

    return { from: from, to: to }
  }, [])

  var [fromDate, setFromDate] = useState(defaultDates.from)
  var [toDate, setToDate] = useState(defaultDates.to)

  var [warehouseOptions, setWarehouseOptions] = useState([ALL_OPTION])
  var [selectedWarehouses, setSelectedWarehouses] = useState([ALL_OPTION])
  var [rowData, setRowData] = useState([])

  var [masterLoaded, setMasterLoaded] = useState(false)
  var [pinnedBottomRows, setPinnedBottomRows] = useState([])

  var skipNextGridEffectRef = useRef(false)
  var requestIdRef = useRef(0)

  function formatRefreshTime(date) {
    if (!date) return "Never"
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
  }

  function getMasterTab(tab) {
    if (tab === "gurgaon") return "gurgaon"
    return "all_warehouses"
  }

  function clearFilters() {
    setFromDate(defaultDates.from)
    setToDate(defaultDates.to)
    setSelectedWarehouses([ALL_OPTION])
  }

  async function fetchWarehousesAndHubsFromApi(tab) {
    try {
      var url = "/msildashboard/fetchWarehousesAndHubs"
      var payload = { tab: getMasterTab(tab) }
      var response = await redirectURL.post(url, payload)
      var data = response && response.data ? response.data.data : null

      if (!Array.isArray(data)) {
        console.warn(
          "Warehouses/Hubs API failed or unexpected:",
          response && response.data ? response.data : response
        )
        return []
      }

      return data
    } catch (e) {
      console.error("fetchWarehousesAndHubsFromApi error:", e)
      return []
    }
  }

  async function fetchNormalWarehouseMonthlyData(payload) {
    try {
      var url = "/msildashboard/fetchTransitDelayNewHeatmap"
      var response = await redirectURL.post(url, payload)
      var responseData =
        response && response.data && (response.data.status.toLowerCase()) === "success"
          ? response.data
          : null

      if (!responseData) {
        console.warn(
          "Normal warehouse API failed:",
          response && response.data ? response.data : response
        )
        return { rows: [], grandTotal: null }
      }

      return {
        rows:
          responseData &&
          responseData.data &&
          Array.isArray(responseData.data.data)
            ? responseData.data.data
            : [],
        grandTotal:
          responseData &&
          responseData.data &&
          responseData.data.grand_total
            ? responseData.data.grand_total
            : null,
      }
    } catch (e) {
      console.error("Normal warehouse API error:", e)
      return { rows: [], grandTotal: null }
    }
  }

  async function fetchGurgaonMonthlyData(payload) {
    try {
      var url = "/msildashboard/fetchTransitDelayHeatmapNewGurgaon"
      var response = await redirectURL.post(url, payload)
      var responseData =
        response && response.data && response.data.status === "Success"
          ? response.data
          : null

      if (!responseData) {
        console.warn(
          "Gurgaon API failed:",
          response && response.data ? response.data : response
        )
        return { rows: [], grandTotal: null }
      }

      return {
        rows:
          responseData &&
          responseData.data &&
          Array.isArray(responseData.data.data)
            ? responseData.data.data
            : [],
        grandTotal:
          responseData &&
          responseData.data &&
          responseData.data.grand_total
            ? responseData.data.grand_total
            : null,
      }
    } catch (e) {
      console.error("Gurgaon API error:", e)
      return { rows: [], grandTotal: null }
    }
  }

  function buildPayload() {
    var selectedValues = Array.isArray(selectedWarehouses)
      ? selectedWarehouses
          .map(function (item) {
            return item.value
          })
          .filter(function (value) {
            return value !== "all"
          })
      : []

    return {
      from_date: fromDate,
      to_date: toDate,
      wh_code: selectedValues.length ? selectedValues : ["all"],
    }
  }

  function getWarehouseLabel(code, tab) {
    var value = String(code || "").trim()

    if (tab === "gurgaon") {
      if (value === "MSILG") return "GGN"
      if (value === "MSILK") return "KKD"
    }

    return value
  }

  function buildWarehouseOptions(masterRows, tab) {
    var seen = {}
    var options = [ALL_OPTION]

    for (var i = 0; i < masterRows.length; i++) {
      var item = masterRows[i]
      if (!item || !item.warehouse) continue

      var code = String(item.warehouse).trim()
      if (!code || seen[code]) continue

      seen[code] = true

      options.push({
        label: getWarehouseLabel(code, tab),
        value: code,
      })
    }

    options.sort(function (a, b) {
      if (a.value === "all") return -1
      if (b.value === "all") return 1
      return String(a.label).localeCompare(String(b.label))
    })

    return options
  }

  function handleWarehouseChange(selected, actionMeta) {
    var values = selected || []

    if (values.length === 0) {
      setSelectedWarehouses([ALL_OPTION])
      return
    }

    var lastPicked =
      actionMeta && actionMeta.option ? actionMeta.option.value : null

    if (lastPicked === "all") {
      setSelectedWarehouses([ALL_OPTION])
      return
    }

    values = values.filter(function (item) {
      return item.value !== "all"
    })

    if (values.length === 0) {
      setSelectedWarehouses([ALL_OPTION])
      return
    }

    setSelectedWarehouses(values)
  }

  async function loadGridData(currentRequestId, warehousesForFilter) {
    try {
      setLoading(true)

      var payload = buildPayload()
      var responseObj = { rows: [], grandTotal: null }

      if (activeSubTab === "gurgaon") {
        responseObj = await fetchGurgaonMonthlyData(payload)
      } else {
        responseObj = await fetchNormalWarehouseMonthlyData(payload)
      }

      if (currentRequestId !== requestIdRef.current) return

      var normalizedRows = normalizeApiRows(responseObj.rows, activeSubTab)

      var bodyRows = []
      var grandTotalRow = null

      for (var i = 0; i < normalizedRows.length; i++) {
        if (normalizedRows[i] && normalizedRows[i].isGrandTotalRow) {
          grandTotalRow = normalizedRows[i]
        } else {
          bodyRows.push(normalizedRows[i])
        }
      }

      setRowData(bodyRows)
      setPinnedBottomRows(grandTotalRow ? [grandTotalRow] : [])
      setLastRefreshTime(new Date())
    } catch (e) {
      if (currentRequestId !== requestIdRef.current) return
      console.error("Grid load failed:", e)
      setRowData([])
      setPinnedBottomRows([])
      setLastRefreshTime(new Date())
    } finally {
      if (currentRequestId === requestIdRef.current) {
        setLoading(false)
      }
    }
  }

  useEffect(
    function () {
      var cancelled = false
      var currentRequestId = ++requestIdRef.current

      async function loadMaster() {
        try {
          setMasterLoaded(false)

          var master = await fetchWarehousesAndHubsFromApi(activeSubTab)
          if (cancelled || currentRequestId !== requestIdRef.current) return

          var options = buildWarehouseOptions(master, activeSubTab)
          setWarehouseOptions(options)

          skipNextGridEffectRef.current = true
          setSelectedWarehouses([ALL_OPTION])

          setMasterLoaded(true)

          loadGridData(currentRequestId, [ALL_OPTION])
        } catch (e) {
          if (cancelled || currentRequestId !== requestIdRef.current) return
          console.error("loadMaster error:", e)

          setWarehouseOptions([ALL_OPTION])

          skipNextGridEffectRef.current = true
          setSelectedWarehouses([ALL_OPTION])

          setMasterLoaded(true)

          loadGridData(currentRequestId, [ALL_OPTION])
        }
      }

      loadMaster()

      return function () {
        cancelled = true
      }
    },
    [activeSubTab]
  )

  useEffect(
    function () {
      if (!masterLoaded) return

      if (skipNextGridEffectRef.current) {
        skipNextGridEffectRef.current = false
        return
      }

      var currentRequestId = ++requestIdRef.current
      loadGridData(currentRequestId, selectedWarehouses)
    },
    [masterLoaded, fromDate, toDate, selectedWarehouses]
  )

  var visibleMonthKeys = useMemo(function () {
    return getVisibleMonthKeys(fromDate, toDate)
  }, [fromDate, toDate])
  function getDelayCellStyle(params) {
  var value = safeNumber(params && params.value)
  var threshold = activeSubTab === "gurgaon" ? 120 : 48

  if (value > threshold) {
    return {
      backgroundColor: "#ffebee",
      color: "#c62828",
      fontWeight: "700",
    }
  }

  if (value <= threshold) {
    return {
      backgroundColor: "#e8f5e9", // light green
      color: "#1b5e20", // dark green text
      fontWeight: "700",
    }
  }

  return null
}

  
  var columnDefs = useMemo(function () {
  var cols = [
    {
      headerName: "Hub",
      field: "hub",
      minWidth: 130,
      maxWidth: 130,
      pinned: "left",
      filter: "agSetColumnFilter",
    },
  ]

  for (var i = 0; i < MONTH_CONFIG.length; i++) {
    var monthItem = MONTH_CONFIG[i]
    if (visibleMonthKeys.indexOf(monthItem.key) !== -1) {
      cols.push({
        headerName: monthItem.label,
        field: monthItem.key,
        minWidth:
          monthItem.label === "September" ||
          monthItem.label === "November" ||
          monthItem.label === "December" ||
          monthItem.label === "February"
            ? 100
            : 80,
         maxWidth:
          monthItem.label === "September" ||
          monthItem.label === "November" ||
          monthItem.label === "December" ||
          monthItem.label === "February"
            ? 100
            : 80,
        valueFormatter: numberFormatter,
        cellStyle: getDelayCellStyle,
      })
    }
  }

  cols.push({
  headerName: "Grand Total",
  field: "grand_total",
  minWidth: 150,
  valueFormatter: numberFormatter,
  cellClass: function (params) {
    if (params && params.data && params.data.grand_total) {
      return "hm-grand-total-col"
    }
    return ""
  },
})

  return cols
}, [visibleMonthKeys, activeSubTab])

  var totalRecords = useMemo(function () {
    return rowData.length
  }, [rowData])

  var pageTitle = useMemo(function () {
    if (activeSubTab === "gurgaon") return "Gurgaon Transit Delay Heatmap"
    return "Warehouse Transit Delay Heatmap"
  }, [activeSubTab])

  var selectedWarehouseText = useMemo(function () {
    if (!selectedWarehouses || selectedWarehouses.length === 0) return "All"
    if (selectedWarehouses.length === 1 && selectedWarehouses[0].value === "all") return "All"

    return selectedWarehouses
      .map(function (item) {
        return item.label
      })
      .join(", ")
  }, [selectedWarehouses])

  return (
    <div className="hmPage">
      <div className="hmSection">
        <DashboardHeaderBanner>
          <div className="hmHeader">
            <div className="hmTitleAccent hmAccentBlue">
              <h2 className="hmTitle">{pageTitle}</h2>
            </div>

            {/* <div className="hmRefresh">
              Last refreshed: {formatRefreshTime(lastRefreshTime)}
              {loading ? <span style={{ marginLeft: 10 }}>(Loading...)</span> : null}
            </div> */}
          </div>
        </DashboardHeaderBanner>

        <div className="hmCard">
          <div className="hmCardHeader">
            <div className="hmCardTitle">Filters</div>
          </div>

          <div className="hmCardBody hmCardBodyCompact">
            <div className="hmFilterGrid">
              <div className="hmField">
                <label className="hmLabel" htmlFor="from-date">From Date</label>
                <input
                  id="from-date"
                  className="hmInput"
                  type="date"
                  value={fromDate}
                  onChange={function (e) {
                    var newFrom = e.target.value
                    if (!isWithinMaxRange(newFrom, toDate)) {
                      window.alert("Date range cannot exceed 1 year. Please pick a From Date within 1 year of the To Date, or change the To Date first.")
                      return
                    }
                    setFromDate(newFrom)
                  }}
                />
              </div>

              <div className="hmField">
                <label className="hmLabel" htmlFor="to-date">To Date</label>
                <input
                  id="to-date"
                  className="hmInput"
                  type="date"
                  value={toDate}
                  onChange={function (e) {
                    var newTo = e.target.value
                    if (!isWithinMaxRange(fromDate, newTo)) {
                      window.alert("Date range cannot exceed 1 year. Please pick a To Date within 1 year of the From Date, or change the From Date first.")
                      return
                    }
                    setToDate(newTo)
                  }}
                />
              </div>

              <div className="hmField">
                <label className="hmLabel">Warehouse</label>
                <div style={{ width: "100%" }}>
                  <Select
                    isMulti
                    className="warehouse-select"
                    classNamePrefix="warehouse-select"
                    options={warehouseOptions}
                    value={selectedWarehouses}
                    onChange={handleWarehouseChange}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                  />
                </div>
              </div>

              <div className="hmField hmFieldBtn">
                <button className="hmBtn hmBtnOutline" type="button" onClick={clearFilters}>
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="hmCard">
          <div className="hmCardHeader">
            <div className="hmCardTitle">{pageTitle}</div>
            <div className="hmSubText">
              Total Rows: <strong>{Number(totalRecords || 0).toLocaleString("en-IN")}</strong>
              {" | Warehouse: " + selectedWarehouseText}
              {" | Date Range: " + fromDate + " to " + toDate}
            </div>
          </div>

          <div className="hmCardBody">
            {loading ? (
              <div className="hmHeatmapLoader">
                <div className="hmHeatmapSpinner"></div>
                <div className="hmHeatmapLoaderText">Loading data...</div>
              </div>
            ) : (
              <div className="ag-theme-balham" style={{ width: "100%", height: 480 }}>
                <AgGridReact
                  rowData={rowData}
                  pinnedBottomRowData={pinnedBottomRows}
                  columnDefs={columnDefs}
                  defaultColDef={{
                    sortable: true,
                    filter: "agSetColumnFilter",
                    resizable: true,
                    minWidth: 120,
                  }}
                  animateRows={true}
                  headerHeight={45}
                  rowHeight={45}
                  suppressCellFocus={true}
                  pagination={true}
                  paginationPageSize={100}
                  paginationPageSizeSelector={[100, 200, 400, 800]}
                    enableRangeSelection={true}
                    overlayNoRowsTemplate={'<span style="padding: 10px; display: inline-block;">No data found</span>'}
              getRowClass={function (params) {
  if (params && params.data && params.data.isGrandTotalRow) {
    return "hm-last-row"
  }
  return ""
}}
                    sideBar={{
                    toolPanels: [
                      {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel",
                        toolPanelParams: {
                          suppressPivotMode: true,
                          suppressRowGroups: true,
                          suppressValues: true,
                        },
                      },
                      {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel",
                      },
                    ],
                  }}
                  statusBar={{
                    statusPanels: [
                      { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
                      { statusPanel: "agTotalRowCountComponent", align: "center" },
                      { statusPanel: "agFilteredRowCountComponent" },
                      { statusPanel: "agSelectedRowCountComponent" },
                      { statusPanel: "agAggregationComponent" },
                    ],
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

function numberFormatter(params) {
  var value = params && params.value != null ? Number(params.value) : 0
  if (isNaN(value)) value = 0
  return value.toLocaleString("en-IN")
}

function safeNumber(value) {
  var n = typeof value === "number" ? value : parseFloat(value || 0)
  return isNaN(n) ? 0 : n
}
function normalizeApiRows(raw, activeSubTab) {
  if (!Array.isArray(raw)) return []

  var out = []

  for (var i = 0; i < raw.length; i++) {
    var item = raw[i]
    if (!item) continue

    var hub =
      item.hub ||
      item.hub_location ||
      item.location ||
      ""

    if (!hub) continue

    var isGrandTotalRow =
      String(hub).trim().toLowerCase() === "grand_total"

    var row = {
      hub: isGrandTotalRow ? "Grand Total" : String(hub).trim(),
      april: safeNumber(item.april != null ? item.april : item.April),
      may: safeNumber(item.may != null ? item.may : item.May),
      june: safeNumber(item.june != null ? item.june : item.June),
      july: safeNumber(item.july != null ? item.july : item.July),
      august: safeNumber(item.august != null ? item.august : item.August),
      september: safeNumber(item.september != null ? item.september : item.September),
      october: safeNumber(item.october != null ? item.october : item.October),
      november: safeNumber(item.november != null ? item.november : item.November),
      december: safeNumber(item.december != null ? item.december : item.December),
      january: safeNumber(item.january != null ? item.january : item.January),
      february: safeNumber(item.february != null ? item.february : item.February),
      march: safeNumber(item.march != null ? item.march : item.March),
      grand_total: safeNumber(item.grand_total),
      isGrandTotalRow: isGrandTotalRow,
    }

    if (!row.grand_total) {
      row.grand_total =
        row.april +
        row.may +
        row.june +
        row.july +
        row.august +
        row.september +
        row.october +
        row.november +
        row.december +
        row.january +
        row.february +
        row.march
    }

    out.push(row)
  }

  return out
}

function normalizeGrandTotalRow(item) {
  if (!item) return null

  return {
    hub: "Grand Total",
    april: safeNumber(item.april != null ? item.april : item.April),
    may: safeNumber(item.may != null ? item.may : item.May),
    june: safeNumber(item.june != null ? item.june : item.June),
    july: safeNumber(item.july != null ? item.july : item.July),
    august: safeNumber(item.august != null ? item.august : item.August),
    september: safeNumber(item.september != null ? item.september : item.September),
    october: safeNumber(item.october != null ? item.october : item.October),
    november: safeNumber(item.november != null ? item.november : item.November),
    december: safeNumber(item.december != null ? item.decmber : item.December),
    january: safeNumber(item.january != null ? item.january : item.January),
    february: safeNumber(item.february != null ? item.february : item.February),
    march: safeNumber(item.march != null ? item.march : item.March),
    grand_total: safeNumber(item.grand_total),
    isGrandTotalRow: true,
  }
}

function formatDateInput(date) {
  var year = date.getFullYear()
  var month = String(date.getMonth() + 1).padStart(2, "0")
  var day = String(date.getDate()).padStart(2, "0")
  return year + "-" + month + "-" + day
}

// The From/To filters had no limit on how wide a range could be selected -
// restrict it to at most 1 year, measured as a calendar year from whichever
// date anchors the range (handles leap years correctly, unlike a fixed
// 365/366-day count).
function isWithinMaxRange(fromStr, toStr) {
  var from = parseDateInput(fromStr)
  var to = parseDateInput(toStr)
  if (!from || !to) return true
  var maxTo = new Date(from)
  maxTo.setFullYear(maxTo.getFullYear() + 1)
  return to <= maxTo
}

function parseDateInput(value) {
  if (!value) return null

  var parts = String(value).split("-")
  if (parts.length !== 3) return null

  var year = parseInt(parts[0], 10)
  var month = parseInt(parts[1], 10) - 1
  var day = parseInt(parts[2], 10)

  if (isNaN(year) || isNaN(month) || isNaN(day)) return null

  return new Date(year, month, day)
}

function getVisibleMonthKeys(fromDate, toDate) {
  var from = parseDateInput(fromDate)
  var to = parseDateInput(toDate)

  if (!from || !to) {
    return MONTH_CONFIG.map(function (item) {
      return item.key
    })
  }

  if (from.getTime() > to.getTime()) {
    return MONTH_CONFIG.map(function (item) {
      return item.key
    })
  }

  var seenMonthIndexes = {}
  var cursor = new Date(from.getFullYear(), from.getMonth(), 1)
  var end = new Date(to.getFullYear(), to.getMonth(), 1)

  while (cursor.getTime() <= end.getTime()) {
    seenMonthIndexes[cursor.getMonth()] = true
    cursor.setMonth(cursor.getMonth() + 1)
  }

  var monthKeys = []
  for (var i = 0; i < MONTH_CONFIG.length; i++) {
    if (seenMonthIndexes[MONTH_CONFIG[i].monthIndex]) {
      monthKeys.push(MONTH_CONFIG[i].key)
    }
  }

  if (monthKeys.length === 0) {
    return MONTH_CONFIG.map(function (item) {
      return item.key
    })
  }

  return monthKeys
}